export const mySociosFeedKeys = {
	all: ['mySociosFeed'] as const,
	favouriteTeam: ['mySociosFeed', 'favouriteTeam'] as const,
	followedTeams: ['mySociosFeed', 'followedTeams'] as const,
	suggestedTeams: ['mySociosFeed', 'suggestedTeams'] as const
};

export const newsFeedKeys = {
	all: ['newsFeed'] as const,
	cheer: ['cheer'] as const,
	get posts() {
		return [...this.all, 'posts'] as const;
	},
	unCheer: ['unCheer'] as const
};

export const userFeedKeys = {
	all: ['userFeed'] as const,
	me: () => [...userFeedKeys.all, 'me'],
	user: (fanId: string) => [...userFeedKeys.all, fanId]
};

export const partnerFeedKeys = {
	all: ['partnerFeed'] as const,
	partner: (partnerId: string) => [...partnerFeedKeys.all, partnerId]
};
